//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    computed: {
        classes() {
            return {
                'has-important-message': this.$store.getters['apidata/hasImportantMessage'],
            };
        },
    },
};
